var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"main-wrapper login-main"},[_c('el-carousel',{attrs:{"height":"calc(100vh - 110px)"}},_vm._l((_vm.banner),function(item,index){return _c('el-carousel-item',{key:index,staticClass:"carousel-item",style:({backgroundImage:'url('+_vm.cdnurl(item)+')'})})}),1),_c('login-view',{attrs:{"redirect":_vm.redirect}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }